import { Observable, Subject } from "rxjs";

//As of now its on the user to avoid bugs from name collisions
export class EventAggregator {
  private static items: Map<EventList, Subject<any>> = new Map<
    EventList,
    Subject<any>
  >();
  constructor() {}

  static get(name: EventList) {
    if (!this.items.get(name)) {
      this.items.set(name, new Subject());
    }
    return this.items.get(name);
  }

  static publish(name: EventList, value: any) {
    if (!this.items.get(name)) {
      this.items.set(name, new Subject());
    }
    this.items.get(name).next(value);
  }
}

export enum EventList {
  popupTriggered,
  popupClosed,
  userSelected,
  processingIndicator,
  dashboardClick,
  logOut,
  messageCaseListRefresh,
  bannerListRefresh,
  refreshCommentThreadInfos,
  refreshDashboard,
  userUpdated,
  caseDetailPrint
}
